import { Footer as AppFooter, Box, Flex } from "@100mslive/react-ui";

import { AudioVideoToggle } from "../AudioVideoToggle";
import { ChatToggle } from "./ChatToggle";
import { EmojiReaction } from "../EmojiReaction";
import { LeaveRoom } from "../LeaveRoom";
import MetaActions from "../MetaActions";
import { MoreSettings } from "../MoreSettings/MoreSettings";
import { PIP } from "../PIP";
import React from "react";
import { ScreenshareAudio } from "../ScreenShareAudio";
import { ScreenshareToggle } from "../ScreenShare";
import { StreamActions } from "../Header/StreamActions";

export const StreamingFooter = () => {
  return (
    <AppFooter.Root
      css={{
        flexWrap: "nowrap",
        "@md": {
          justifyContent: "center",
        },
      }}
    >
      <AppFooter.Left
        css={{
          "@md": {
            w: "unset",
            p: "0",
          },
        }}
      >
        <AudioVideoToggle />
      </AppFooter.Left>
      <AppFooter.Center
        css={{
          "@md": {
            w: "unset",
          },
        }}
      >
        <ScreenshareAudio css={{ "@sm": { display: "none" } }} />
        <ScreenshareToggle css={{ "@sm": { display: "none" } }} />
        <Box css={{ "@md": { display: "none" } }}>
          <PIP />
        </Box>
        <Box
          css={{
            display: "none",
            "@md": {
              display: "flex",
              alignItems: "center",
              mx: "$4",
            },
          }}
        >
          <StreamActions />
        </Box>
        <MoreSettings />
        <Box css={{ "@md": { display: "none" } }}>
          <LeaveRoom />
        </Box>
        <Flex
          align="center"
          css={{ display: "none", "@md": { display: "flex" } }}
        >
          <ChatToggle />
        </Flex>
      </AppFooter.Center>
      <AppFooter.Right>
        {/* <EmojiReaction /> */}
        <MetaActions />
        <ChatToggle />
      </AppFooter.Right>
    </AppFooter.Root>
  );
};
